<template>
  <div class="about">
    <div class="about-left">
      <div class="about-left-content">
        <h4>Кои сме ние</h4>
        <p>
          cDots е компания с над 15 години опит с клиенти в България, Англия,
          Турция, Австралия, Испания. Компанията е създадена в края на 2010 и
          покрива пълния спектър от ИТ продукти и услуги в това число разработка
          на специализиран софтуер.
        </p>
        <p>
          Програмите, който създаваме намаляват разходите, спестяват средства и
          улесняват работата на предприятията. Ние не продаваме софтуерни
          лицензи – ние сме производител на програми с които клиентите ни
          печелят и се развиват.
        </p>
        <p>
          Разработваме решения, които подпомагат бизнеса. Програми за
          производство, търговия, управление, анализи. За тези над 15 години
          компанията ни има над 60 международни клиента, включващи малки и
          средни компании. Фирми от няколко човека персонал, през предприятия от
          така наречения Enterprise клас – опериращи на няколко континента.
        </p>
        <p>Създаваме Успех. Реализираме амбиции.</p>
        <div class="tabs">
          <div class="tab" :class="{ 'tab-active': activeTab === 3 }" @click="activeTab = 3">
            Полезна
            <br />Информация
          </div>
          <div class="tab" :class="{ 'tab-active': activeTab === 0 }" @click="activeTab = 0">
            Видео
            <br />Презентации
          </div>
          <div class="tab" :class="{ 'tab-active': activeTab === 1 }" @click="activeTab = 1">
            Снимки
          </div>
          <div class="tab" :class="{ 'tab-active': activeTab === 2 }" @click="activeTab = 2">
            Събития
          </div>
        </div>
        <div class="tab-content">
          <div class="content-row" v-for="(x, i) in content[activeTab]" :key="`item-${i}`"
            :class="{ 'has-actions': x.extraButtons }" @click="
              !x.extraButtons && (activeTab === 1 ? openPhoto(x) : openVideo(x))
              ">
            <img :src="activeTab === 1
              ? x.images[0]
              : `/static/img/about/thumbnails/${x.id}.webp`
              " alt />
            <div class="content-texts">
              <p>{{ x.title }}</p>
              <p>{{ x.description }}</p>

              <section v-if="x.extraButtons" class="content-btns">
                <button @click.stop="openVideo(x)">
                  <img src="/static/img/about/youtube.png" alt="youtube img" />
                  Гледай в Youtube
                </button>
                <button @click.stop="openAudio(x)">
                  <img src="/static/img/about/audio.png" alt="audio img" />
                  Слушай аудио подкаст
                </button>
              </section>
            </div>
          </div>
        </div>
        <br />
        <!-- <img
          class="header-img"
          width="100%"
          height="auto"
          src="/static/img/eu.png"
          alt="Preview"
        /> -->
        <!-- <p>
          „СИ ДОТС ЕООД“ ЕООД стартира изпълнението на договор за безвъзмездна
          финансова помощ BG16RFOP002-2.073-25168-C01 по проект „Преодоляване
          недостига на средства и липсата на ликвидност, настъпили в резултат от
          епидемичния взрив от COVID-19”. Договорът е по процедура
          BG16RFOP002-2.073 „Подкрепа на микро и малки предприятия за
          преодоляване на икономическите последствия от пандемията COVID-19”
          финансиран от Оперативна програма „Иновации и конкурентоспособност”
          2014-2020, съфинансирана от Европейския съюз чрез Европейския фонд за
          регионално развитие.
        </p>
        <p>
          Целта на проекта е oсигуряване на оперативен капитал за справяне с
          последиците от пандемията COVID-19. Постигане на положителен ефект за
          преодоляване на икономическите последствия от пандемията COVID-19 и
          стабилност на работните места.
        </p>
        <p>
          Общата стойност на проекта е 10 000.00 лева, като размерът на
          безвъзмездната финансова помощ е 100%, от които 8500.00 лв. европейско
          и 1500.00 лв. национално съфинансиране.
        </p>
        <p>
          Проектът стартира на 30.09.2020 г. и е с продължителност 3 месеца.
        </p> -->
      </div>
    </div>
    <div class="about-right"></div>
    <img class="about-img-mobile" src="/static/img/about/about_m.png" alt="About us" />
    <transition name="fade">
      <Modal v-if="isModalOpened" :audio="selectedAudio" :video="selectedAudio
        ? false
        : activeTab === 1
          ? null
          : `https://www.youtube.com/embed/${selectedVideo}`
        " :photos="activeTab === 1 ? selectedPhoto : null" />
    </transition>
  </div>
</template>

<script>
import sendInquiry from "./mixins/sendInquiry.js";
import Modal from "./shared/Modal";
export default {
  components: {
    Modal: Modal,
  },
  mixins: [sendInquiry],
  data() {
    return {
      isModalOpened: false,
      selectedVideo: "",
      selectedPhoto: {},
      selectedAudio: null,
      activeTab: 3,
      content: [
        // VIDEOS
        [
          {
            id: "UI50wxIMyfE",
            title: "Оптимизиране работата на хората чрез технологиите",
            description:
              "Участие на управителя на Си Дотс Филип Дечев в ТВ +, Октомври 2017",
          },
          {
            id: "axUj4QUM6Qo",
            title:
              "Българска компания с уникален софтуер за решение на бизнес операциите",
            description:
              "Участие на управителя на Си Дотс Филип Дечев в ТВ Европа, 20 Октомври 2017",
          },
          {
            id: "Rv_Z-3U8c0I",
            title:
              "Представяне на ИТ отдела във фирма Си Дотс ЕООД от управителя",
            description:
              "Представяне на ИТ отдела във фирма Си Дотс ЕООД от управителя",
          },
          {
            id: "9lgpbgo4GdM",
            title: "Си Дотс - кратко представяне на фирмата от управителя",
            description:
              "Кратко представяне на фирма Си Дотс от нейния управител, за създаването до сега",
          },
        ],
        // PHOTOS
        [
          {
            images: [
              "/static/img/about/photos/6/1.webp",
              "/static/img/about/photos/6/2.webp",
              "/static/img/about/photos/6/3.webp",
              "/static/img/about/photos/6/4.webp",
              "/static/img/about/photos/6/5.webp",
              "/static/img/about/photos/6/6.webp",
              "/static/img/about/photos/6/7.webp",
              "/static/img/about/photos/6/8.webp",
              "/static/img/about/photos/6/9.webp",
              "/static/img/about/photos/6/10.webp",
              "/static/img/about/photos/6/11.webp",
              "/static/img/about/photos/6/12.webp",
              "/static/img/about/photos/6/13.webp",
              "/static/img/about/photos/6/14.webp",
              "/static/img/about/photos/6/15.webp",
              "/static/img/about/photos/6/16.webp",
            ],
            videoId: "VR3lKIbcJpM",
            title: "Как работят някои от нашите клиенти",
            description:
              "Производствено предприятие за метални конструкции и елементи, пълна система за управление на работните станции.",
          },
          {
            images: [
              "/static/img/about/photos/0/1.webp",
              "/static/img/about/photos/0/2.webp",
              "/static/img/about/photos/0/3.webp",
              "/static/img/about/photos/0/4.webp",
              "/static/img/about/photos/0/5.webp",
              "/static/img/about/photos/0/6.webp",
              "/static/img/about/photos/0/7.webp",
            ],
            title: "Откриване на завод Одело край Пловдив",
            description:
              "Завод Отело беше изграден с помощта на софтуера за строителство и отчитане на СМР на фирма Си Дотс",
          },
          {
            images: [
              "/static/img/about/photos/1/1.webp",
              "/static/img/about/photos/1/2.webp",
              "/static/img/about/photos/1/3.webp",
            ],
            title: "Участие в Българо-Индийски Бизнес Форум",
            description:
              "Представяне дейността на фирмата, пред индийски компании в София, България",
          },
          {
            images: [
              "/static/img/about/photos/2/1.webp",
              "/static/img/about/photos/2/2.webp",
            ],
            title: "Фирмен живот",
            description: "Как протича работния процес",
          },
          {
            images: [
              "/static/img/about/photos/3/1.webp",
              "/static/img/about/photos/3/2.webp",
              "/static/img/about/photos/3/3.webp",
            ],
            title: "Първо представяне 2011г.",
            description:
              "Бизнес закуска с първите клиенти на Си Дотс - тогава с наименование НАБАКО България",
          },
          {
            images: [
              "/static/img/about/photos/4/1.webp",
              "/static/img/about/photos/4/2.webp",
              "/static/img/about/photos/4/3.webp",
              "/static/img/about/photos/4/4.webp",
            ],
            title: "Първата инвестиция на Си Дотс",
            description:
              " Първата ни инвестиция беше на по-голяма стойност от апартамента в който се помещавахме",
          },
          {
            images: [
              "/static/img/about/photos/5/1.webp",
              "/static/img/about/photos/5/2.webp",
              "/static/img/about/photos/5/3.webp",
              "/static/img/about/photos/5/4.webp",
              "/static/img/about/photos/5/5.webp",
              "/static/img/about/photos/5/6.webp",
              "/static/img/about/photos/5/7.webp",
            ],
            title: "Историята в картинки",
            description: "Фирмата стартира с едно бюро в празен офис",
          },
        ],
        // EVENTS
        [
          {
            id: "eUcCJrWNaCs",
            title:
              "Си Дотс – внедряване на нов продукт или експанзия в нова държава",
            description:
              "Лекция пред предприемачи от цялата страна, гр. Варна, 2018г. Филип Дечев – управител Си Дотс ЕООД като гост на Сдружение на Предприемачите „Лудогорие“",
          },
          {
            id: "cBdGrcs9XGM",
            title: "Си Дотс – иновации, кооперации, операции",
            description:
              "Лекция пред предприемачи от цялата страна, гр. Варна, 2017г. Филип Дечев – управител Си Дотс ЕООД като гост на Сдружение на Предприемачите „Лудогорие“",
          },
          {
            id: "aOPM3noQewY",
            title:
              "Speech by Chief Commercial Counsellor of the Embassy of the Republic of Turkey",
            description:
              "Event organized by cDots in Sofia for Turkish investor and kind participation of Commercial Counsellor of the Embassy of the Republic of Turkey",
          },
          {
            id: "rVes43y0uJA",
            title: "Си Дотс – представяне пред инвеститори от Турция",
            description:
              "Представяне пред инвеститори от Турция на семинар организиран от Си Дотс с участието на Търговското аташе на Р.Турция и посланици на търговски организации",
          },
          {
            id: "liw-hmkiBmo",
            title: "cDots – Presentation by cDots’ regional manager Caner Uzen",
            description:
              "Presentation of regional manager Caner Uzen in Bulgarian-Turkish Business Forum organized by cDots",
          },
          {
            id: "2gOOOoFz_x8",
            title: "Си Дотс подготовка за презентация",
            description:
              "cDots Ltd. presents its strategy for business development with partners from the Bulgarian-Turkish Industrial Chamber",
          },
          {
            id: "UJMtJRn3kVs",
            title: "Си Дотс – електронна търговия",
            description:
              "Лекция пред предприемачи от цялата страна, гр. Варна, 2016г. Филип Дечев – управител Си Дотс ЕООД като гост на Сдружение на Предприемачите „Лудогорие“",
          },
        ],
        [
          //  Подкаст 4
          {
            id: "3P8IDF4prs4",
            extraButtons: true,
            audio: {
              title:
                "Подкаст 3 | Как да напишем успешно задание за IT проект?",
              src: "https://cdn.cdots.bg/cdots/audio4.mp3",
              description: `
<p>
  Филип Дечев обяснява как една компания трябва да подготви задание към IT фирма за разработка или внедряване на софтуер. Основната препоръка е процесът да започне с внимателно събиране на изискванията от всички отдели, позиции и ключови процеси в компанията.</p>

<div>
   <p>
    Изискванията трябва да се разделят на три групи: задължителни функции, пожелателни функции и „мечти“. Авторът подчертава, че първоначалното задание не трябва да бъде огромен документ, а кратко и ясно описание, фокусирано само върху най-необходимото.
  </p>
</div>

<div>
    <p>
    Най-честата грешка е компаниите да включват в заданието неща, които в момента не правят, но биха искали да правят. Според текста успешният проект трябва да започне от реално необходимите процеси, а не от хипотетични желания.
  </p>
</div>

<div>
    <p>
    Вторият основен акцент е опростяването. Ако една компания автоматизира сложни, бавни и тежки процеси без да ги преработи, новата система само ще направи работата още по-сложна. Затова авторът формулира принципа: опростяване, опростяване, опростяване.
  </p>
</div>

<div>
   <p>
    Заключението е, че успешното внедряване започва с най-важните функции, реализирани по най-простия възможен начин. След това самата практика и служителите ще покажат кои допълнителни функции наистина са нужни.
  </p>
</div>
`,
            },
            title:
              "▶️ Как да напишем успешно задание за IT проект?",
            description:
              "Филип Дечев обяснява как една компания трябва да подготви задание към IT фирма за разработка или внедряване на софтуер. Основната препоръка е процесът да започне с внимателно събиране на изискванията от всички отдели, позиции и ключови процеси в компанията.",
          },
          //  Подкаст 3 Извънреден 
          {
            id: "LebdhV6oERE",
            extraButtons: true,
            audio: {
              title:
                "Подкаст Извънреден | Тенденции в дигитализацията на строителството от DigitalBAU 2026",
              src: "https://cdn.cdots.bg/cdots/audio3.mp3",
              description: `
<p>
  Филип Дечев представя впечатления от изложението DigitalBAU 2026, посветено на дигиталните технологии в строителството. Основният извод е, че секторът се движи към по-интегрирани софтуерни системи, в които строителната документация, чертежите, договорите, количествено-стойностните сметки и протоколите вече се съхраняват директно в платформите, а не във файлови сървъри и отделни папки.</p>

<div>
   <p>
    Друг важен акцент е визуализацията на строителните обекти чрез карти, включително информация за активност, налични ресурси, хора и механизация. Разгледани са и решения за проследяване на машини, инвентар и оборудване чрез QR кодове, NFC тагове, смарт тагове и геолокация, което улеснява електронното предаване и отчетността.
  </p>
</div>

<div>
    <p>
    Текстът подчертава също нарастващата роля на визуалната информация вместо класически таблични справки, както и първите опити за използване на AI при планиране на строителни дейности, ресурси, материали и механизация. Споменати са и роботизирани решения, като робот-куче за заснемане и измерване на помещения, както и прототипи за акустична проверка на извършени строително-монтажни работи.
  </p>
</div>

<div>
   <p>
    В заключение се отбелязва, че AI разработките в Европа все още са ограничени заради притеснения относно сигурността, ноу-хауто и използването на американски или неевропейски технологии, особено при инфраструктурни и критични обекти.
  </p>
</div>
`,
            },
            title:
              "▶️ Тенденции в дигитализацията на строителството от DigitalBAU 2026",
            description:
              "Филип Дечев представя впечатления от изложението DigitalBAU 2026, посветено на дигиталните технологии в строителството.",
          },
          //  Подкаст 2 
          {
            id: "dRk-UhKfrCg",
            extraButtons: true,
            audio: {
              title:
                "Подкаст 2 | cDots Успешен проект, условия и добри практики!",
              src: "https://cdn.cdots.bg/cdots/audio2.mp3",
              description: `
<p>
  Казвам се Филип Дечев и като собственик на софтуерната компания СиДотс често споделям опита си по една ключова тема за бизнеса: как да се подготви и реализира успешен софтуерен проект – такъв, който да бъде изпълнен в срок, в рамките на бюджета и с реално постигнати резултати. Ето основните акценти, на които винаги обръщам внимание:
</p>

<div>
  <p><strong>1 - Аналогията с покупка на техника.</strong></p>
  <p>
    Софтуерният проект не се „купува“, защото другите имат такъв. Подходът трябва да е същият, както при избора на специализирана машина или автомобил – с ясни критерии за нужната мощност, ефективност и конкретните задачи, които трябва да бъдат решени. Ако не знаете за какво точно ще използвате софтуера, шансът да останете разочаровани е много голям.
  </p>
</div>

<div>
  <p><strong>2 – Изборът на правилния Ръководител проект (Project Manager).</strong></p>
  <p>
    Това е най-критичната стъпка от целия процес. Подходящият ръководител е вътрешен човек от компанията – такъв, който познава отлично бизнес процесите, колегите си и ежедневната реалност. Той трябва да има авторитет и да може свободно да комуникира както с мениджмънта, така и с крайните служители. По моя опит собственикът на фирмата, новоназначени служители или системни администратори обикновено не са добър избор за тази роля.
  </p>
</div>

<div>
  <p><strong>3 – Подготовката преди първия контакт с IT фирма. Тук има три задължителни елемента:</strong></p>
  <ul style="list-style-position: inside; padding-left: 20px;">
    <li>
      <strong>Дефиниране на приоритети</strong> – не може да се постигне всичко наведнъж. Нужно е ясно да се определят най-важните цели.
    </li>
    <li>
      <strong>Вътрешно „продаване“ на идеята</strong> – служителите трябва да припознаят софтуера като решение на техните ежедневни проблеми, например по-лесно проследяване на поръчки, а не като поредната допълнителна тежест.
    </li>
    <li>
      <strong>Ясно задание</strong> – конкретни цели и разумен времеви график, които да служат като основа за целия проект.
    </li>
  </ul>
</div>

<p>
  В заключение, успешният софтуерен проект започва много преди писането на първия ред код – с правилна нагласа, ясни приоритети и подготвен екип. В следващата част ще се спра подробно на избора на подходящ IT изпълнител.
</p>
`,
            },
            title:
              "▶️ cDots Успешен проект, условия и добри практики!",
            description:
              "Споделяне опита за това как да се подготви и реализира Успешен софтуерен проект (изпълнен в срок, в бюджет и с постигнати резултати). Изборът на подходящ Project Manager – вътрешен човек, който познава добре компанията, изясняване на целите, приоритетите и очакваните резултати, други.",
          },
          //  Подкаст 1 
          {
            id: "7GJid9lXikg",
            extraButtons: true,
            audio: {
              title:
                "Подкаст 1 | Как ще ми гарантираш сигурността на информацията и ноу-хау-то ми?",
              src: "https://cdn.cdots.bg/cdots/audio1.mp3",
              description: `
<p>
  Казвам се Филип Дечев и като управител на софтуерната компания СиДотс често се сблъсквам с един от най-важните въпроси за моите клиенти: как гарантирам конфиденциалността на фирмената информация и ноу-хау? Отговорът ми се основава на три основни аргумента:
</p>

<div>
  <p><strong>1 - Професионален опит и репутация.</strong></p>
  <p>
    Имам 25 години професионален опит, от които 15 години със СиДотс, като през това време съм работил с големи и сериозни структури, включително КЦМ и „Главболгарстрой“. През целия този период не е имало нито един случай на изтичане на информация, нито дори намек за подобно искане – било то от клиенти или от конкуренти. Репутацията ми е изграждана с години и е най-ценният ми актив.
  </p>
</div>

<div>
  <p><strong>2 - Икономическа и правна логика.</strong></p>
  <p>
    Нито един подкуп не си струва риска. Бизнесът ми носи стабилни и напълно легални доходи, които бих загубил мигновено при евентуално разкритие. Освен това съществуват сериозни законови последствия, включително наказателна отговорност и затвор, както и договори за конфиденциалност. Всичко това прави разгласяването на фирмени тайни абсолютно неприемливо – както морално, така и рационално.
  </p>
</div>

<div>
  <p><strong>3 - Спецификата на бизнес процесите и ноу-хау.</strong></p>
  <p>
    Моят опит показва, че уникалният начин на работа на една фирма много често е неприложим за друга, дори когато става дума за преки конкуренти. Мога да дам пример с три фирми за електроизграждане, които работят по коренно различни модели на фактуриране и управление на материали. Това, което е перфектно решение за едната, е напълно неприложимо за другата. Именно затова „кражбата“ на ноу-хау в повечето случаи е безсмислена.
  </p>
</div>

<p>
  В заключение, искам ясно да уверя клиентите си, че техните данни и фирмена информация са защитени чрез комбинация от професионална етика, личен интерес и практическата специфика на бизнеса, в който работим. Това е ангажимент, който приемам лично и без компромиси.
</p>
`,
            },
            title:
              "▶️ Как ще ми гарантираш сигурността на информацията и ноу-хау-то ми?",
            description:
              "В настоящото клипче бих искал да Ви отговоря на един въпрос, който ми задават рядко, но мисля, че все пак всички ги интересува, а именно: Как ще гарантираш защита на информацията ми в твоите решения и начина ми на работа, че няма да ги разпространиш с моите конкуренти или клиенти?",
          },
          //  Подкаст 1 край 
        ],
      ],
    };
  },
  methods: {
    openVideo(v) {
      this.selectedVideo = v.id;
      this.isModalOpened = true;
    },
    openAudio(x) {
      this.selectedAudio = x.audio;
      this.isModalOpened = true;
    },
    openPhoto(p) {
      this.selectedPhoto = p;
      this.isModalOpened = true;
    },
  },
  mounted() {
    this.$on("close-modal", () => {
      this.isModalOpened = false;
      this.selectedAudio = null;
      this.selectedVideo = "";
      this.selectedPhoto = {};
    });
  },
  destroyed() {
    this.$off("close-modal");
  },
};
</script>

<style scoped>
.about-img-mobile {
  display: none;
}

.about {
  display: flex;
  height: 100vh;
  margin-top: -145px;
  min-height: 1px;
}

.header-img {
  mix-blend-mode: multiply;
}

/* LEFT */
.about-left {
  background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 1px;
  padding: 160px 0 0 0;
  width: 50%;
}

.about-left-content {
  display: flex;
  flex-direction: column;
  padding: 0 50px 50px 100px;
  overflow: auto;
  height: 100%;
}

.about-left-content::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.about-left-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.about-left-content::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.about-left-content::-webkit-scrollbar-thumb:hover {
  background: #c9c9c9;
}

.about-left h4 {
  margin: 15px 0;
}

.about-left p {
  color: #000;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 20px;
}

.about-left ul {
  padding-left: 20px;
}

.about-left li {
  color: #000;
  font-size: 14px;
  line-height: 22px;
}

.tabs {
  display: flex;
  justify-content: center;
  margin: 15px 0;
  width: 100%;
}

.tab-content {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  /* height: 100%; */
}

.tab {
  align-items: center;
  background-color: #f8f8f8;
  border-radius: 4px;
  color: #3f3f3f;
  cursor: pointer;
  display: inline-flex;
  height: 60px;
  justify-content: center;
  line-height: 16px;
  margin-right: 20px;
  padding: 10px;
  text-align: center;
  width: 160px;
}

.tab:last-child {
  margin-right: 0;
}

.tab:hover {
  background-color: #c9c9c9;
}

.tab-active {
  background-color: #c9c9c9;
  font-weight: 700;
}

.content-row {
  align-items: flex-start;
  border-bottom: 1px solid #c9c9c9;
  cursor: pointer;
  display: flex;
  padding: 8px;
  width: 100%;
}

.content-row.has-actions {
  cursor: default;
}

.content-row:first-child {
  border-top: 1px solid #c9c9c9;
}

.content-row img {
  border-radius: 4px;
  display: block;
  height: auto;
  margin-right: 20px;
  width: 140px;
}

.content-row .content-texts {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}

.content-row .content-texts p {
  margin: 5px 0 0;
  line-height: 16px;
}

.content-row .content-texts p:last-child {
  opacity: 0.7;
  font-size: 13px;
}

.content-row:not(.has-actions):hover {
  background-color: rgba(201, 201, 201, 0.1);
}

.content-btns {
  display: flex;
  gap: 5px;
}

.content-btns button {
  align-items: center;
  background: #c24e50;
  border-radius: 4px;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  gap: 5px;
  height: 30px;
  padding: 8px 15px;
  transition: all 0.3s;
}

.content-btns button:hover {
  background: #b33b3b;
}

.content-btns button:last-of-type {
  background: #6769ae;
}

.content-btns button:last-of-type:hover {
  background: #5a5c96;
}

.content-btns img {
  margin: initial;
  width: auto;
}

/* RIGHT */
.about-right {
  align-items: center;
  background-image: url("/static/img/about/about.webp");
  background-size: cover;
  background-position: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 1px;
  padding: 160px 0 25px;
  width: 50%;
}

/* RESPONSIVE */
@media screen and (max-width: 1600px) {
  .about-left {
    padding-top: 140px;
  }

  .about-left p {
    margin-bottom: 15px;
  }

  .tabs {
    margin: 0 0 10px;
  }

  .tab {
    font-size: 13px;
    line-height: 12px;
    height: 45px;
    width: 140px;
  }
}

@media screen and (max-width: 1440px) {
  .about {
    margin-top: -100px;
  }

  .about-left p,
  .about-left li {
    font-size: 14px;
  }

  .about-left p {
    margin-bottom: 15px;
  }

  .content-row .content-texts p:last-child {
    font-size: 11px;
  }
}

@media screen and (max-width: 1280px) {
  .about {
    flex-direction: column;
    height: initial;
  }

  .about-left {
    min-height: initial;
    padding: 100px 50px 50px;
    width: 100%;
  }

  .about-right {
    display: none;
  }

  .about-img-mobile {
    display: block;
    width: 100%;
  }

  .about-showcase {
    padding: 0;
  }

  .about-right {
    padding: 50px 20px 63px;
  }

  .about-left-content {
    padding: 0;
    overflow: initial;
  }
}

@media screen and (max-width: 600px) {
  .about-left {
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .content-row {
    padding: 8px 0;
  }

  .content-row .content-texts p:last-child {
    font-size: 10px;
  }

  .content-row .content-btns {
    flex-wrap: wrap;
  }

  .content-row .content-btns button {
    justify-content: center;
    width: 100%;
  }

  .tab:not(:last-child) {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue